module.exports = __webpack_public_path__ + "img/home-image.19f916aa.png";